<script>
export default {
  name: 'ShipConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isMove: {
      type: Boolean,
      default: () => [],
      required: false,
    },
    warehouseId: {
      type: [Number, String],
      default: null,
      required: true,
    },
    btnProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      formValidState: false,
      toOrganisation: null,
      rules: {
        toOrganisation: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    organisations() {
      let organisations = this.isMove
        ? this.$store.getters['data/getWarehouses']
        : this.$store.getters['data/getWorkshopsFromOrganizations']
      if (this.warehouseId) {
        let warehouse = this.$store.getters['data/getItemFromDictionary'](
          'organization',
          this.warehouseId
        )
        return organisations.filter(w => {
          return w.parent === warehouse.parent && w.id !== warehouse.id
        })
      } else {
        return organisations
      }
    },
  },
  methods: {
    applyClicked() {
      this.$emit('apply-clicked', { toOrganisation: this.toOrganisation })
      this.toOrganisation = null
    },
    closeDialog() {
      this.$emit('close-clicked')
      this.toOrganisation = null
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialogShow"
    max-width="355">
    <v-card>
      <v-card-title class="headline text-xs-center">
        <v-spacer />
        <slot />
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newItemForm"
                v-model="formValidState">
                <v-layout 
                  row 
                  align-center>
                  <v-flex>
                    <v-select
                      :items="organisations"
                      :label="isMove ? $t('label__toWarehouse') : $t('label__toWorkshop')"
                      :rules="rules.toOrganisation"
                      v-model="toOrganisation"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click.native="closeDialog"
        >
          {{ $t('buttons__cancel') }}
        </v-btn>
        <v-btn
          :disabled="!formValidState || isLoading"
          :loading="loading"
          :color="btnProps.color"
          @click.native="applyClicked"
        >
          {{ btnProps.text }}
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
